import { useQuery } from "@tanstack/react-query";
import { useExportManagementAPI } from "../../dataServices/exports/useExportManagementAPI";

type UseScheduledExportArgs = {
  orgId?: string;
  scheduledExportId?: string;
};

export function useScheduledExportQuery({
  orgId,
  scheduledExportId,
}: UseScheduledExportArgs) {
  const api = useExportManagementAPI();
  const schedulePk = decodeURIComponent(scheduledExportId ?? "");
  return useQuery({
    queryKey: ["getScheduledExport", orgId, schedulePk],
    enabled: Boolean(orgId && scheduledExportId && api.isReady),
    queryFn: async () => {
      const scheduledExport = await api.getOneScheduledExport(
        orgId ?? "",
        schedulePk
      );
      return scheduledExport;
    },
  });
}
